import React from "react";
import "./styles.less";

const Safety = ({ main_domain }: { main_domain: string }) => {
	return (
		<div className="safety">
			<h2>Recomendaciones para Compra Venta y Arriendo de Inmuebles</h2>
			<p>
				<a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a> informa que todo proceso
				de compra-venta es responsabilidad única y exclusiva del comprador y del vendedor.
			</p>
			<p>
				Las recomendaciones aquí descritas tienen la finalidad de ayudar a realizar las
				transacciones de forma más segura y disminuir el riesgo de estafa, pero en ningún
				caso implican un traspaso de responsabilidad hacia fincaraiz.com.co.
			</p>
			<p>
				Asegúrese de conservar los emails relacionados con las transacciones; estas
				comunicaciones escritas son la mejor forma de comprobar las obligaciones asumidas
				por ambas partes en la operación.
			</p>

			<h4>¿Cómo reconocer una oferta falsa?</h4>
			<ul>
				<li>Precios excesivamente baratos, en venta o alquiler, solicitando dinero por anticipado.</li>
				<li>No disponibilidad de imágenes o imágenes adicionales a las publicadas.</li>
				<li>Prisa excesiva en realizar negocios.</li>
				<li>Evasivas para enseñar copias de documentos actualizados.</li>
				<li>Inconsistencia en datos o no atención a los teléfonos originalmente publicados.</li>
			</ul>

			<h4>Consejos para Compradores</h4>
			<ul>
				<li>
					Pregunte, manifieste su interés en la oferta realizando preguntas que le
					permitan saber un poco más del inmueble publicado. Indague sobre las condiciones
					del inmueble y solicite más fotos para reafirmar la información que ya tiene.
				</li>
				<li>
					Sea cauteloso, no comparta sus datos personales, sin antes verificar el
					destinatario, tales como dirección de su casa o lugar de empleo. Limite su
					información personal, no proporcione datos adicionales como números de cuenta o
					tarjetas de crédito, etc. Cuídese de entregar detalles de sus finanzas personales
					como extractos bancarios a personas desconocidas.
				</li>
				<li>
					Comuníquese con el vendedor, no contacte al anunciante solo por medio
					electrónico, establezca comunicación telefónica. Evite negociar solamente vía
					teléfono celular (siempre conviene tener también un teléfono de línea fijo)
					antes de reunirse con él.
				</li>
				<li>
					Reúnase en un lugar público, elija siempre lugares públicos con circulación de
					personas alrededor, durante el día preferiblemente.
				</li>
				<li>
					No asista solo a las citas, infórmele a alguien dónde estará y los datos de la
					persona con quien se reunirá.
				</li>
				<li>
					Investigue, consulte los valores del sector y sus características, dude de
					ofertas muy económicas o que tengan prisa en realizar negocio.
				</li>
				<li>
					Conozca antes de negociar. Es aconsejable llegar a un acuerdo para poder ver el
					inmueble e inspeccionarlo antes de comprar. Antes de cerrar la transacción,
					asegúrese de que el inmueble cumple con lo que espera de él; así evitará
					posibles inconvenientes.
				</li>
				<li>
					No envíe o entregue dinero por anticipado como garantía, sin verificar los datos
					del destinatario. Se han dado casos en los que después de que el comprador hace
					el pago, desaparece todo rastro de contacto del vendedor.
				</li>
				<li>
					Desconfíe de vendedores que no pueden hablar por teléfono por cualquier excusa.
				</li>
			</ul>

			<h4>Consejos para Vendedores</h4>
			<ul>
				<li>
					Use imágenes, sea descriptivo y preciso en la información del inmueble para dar
					una idea previa del mismo.
				</li>
				<li>
					Sea cauteloso, preferiblemente no publique los teléfonos que den indicios de su
					lugar de trabajo, si el número de contacto es el de su casa sea precavido al
					compartir información.
				</li>
				<li>
					Evite contestar los emails desde correos empresariales, use preferiblemente los
					emails de servidores generales como Hotmail, Yahoo o Gmail.
				</li>
				<li>
					Responda a las preguntas, conteste todas las dudas que los interesados en su
					oferta puedan tener, ya sea por teléfono o por e-mail.
				</li>
				<li>
					Desconfíe de compradores que no pueden hablar por teléfono por cualquier excusa.
				</li>
				<li>
					Evite hacer negocios con personas no locales, no acepte ofertas de contactos que
					no pueda conocer en persona. No acepte cheque de bancos extranjeros, no utilice
					sistemas de pago que no puedan garantizar transacciones con desconocidos.
				</li>
				<li>
					Reúnase en lugares públicos, si necesita estar en un lugar específico, evite
					estar solo, si está enseñando su casa, programe las visitas para una hora y día
					específicos, avise a sus vecinos que hay personas llegando a su casa.
				</li>
				<li>
					Negocie, es posible que algún comprador esté dispuesto a hacer una contraoferta;
					esté preparado para negociar el precio y los términos de la transacción, pero
					tenga claro cuál es su objetivo.
				</li>
				<li>
					Sea precavido, preferiblemente no acepte cheques personales. Deje claro desde el
					principio todos los detalles de la transacción, condiciones de pago y plazos de
					tiempo, así evitará incidentes futuros.
				</li>
				<li>
					Proteja su información personal, no proporcione sus números de cuenta, números
					de tarjetas de crédito, etc.
				</li>
				<li>
					Elimine el aviso del portal cuando haya vendido, para evitar seguir recibiendo
					solicitudes sobre el aviso publicado. Una vez sea vendido o alquilado, asegúrese
					de retirar la oferta.
				</li>
			</ul>

			<p>
				<a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a> no interviene en las
				negociaciones ni transacciones entre ninguna de las partes, tampoco asegura el
				cumplimiento de cualquier condición negociada. No somos intermediarios, ni
				cobramos comisión.
			</p>
		</div>
	);
};

export default Safety;
